import { render, staticRenderFns } from "./Stereosynthesis.vue?vue&type=template&id=13239e52&scoped=true&"
import script from "./Stereosynthesis.vue?vue&type=script&lang=js&"
export * from "./Stereosynthesis.vue?vue&type=script&lang=js&"
import style0 from "./Stereosynthesis.vue?vue&type=style&index=0&id=13239e52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13239e52",
  null
  
)

export default component.exports